import { Spinner } from '@lexhero/park-ui';

export default function RootLoader() {
    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff',
                zIndex: 9999,
            }}
        >
            <Spinner size="xl" />
        </div>
    );
}
